export const EVENTS = {
  CV: {
    CREATED: "cv_created",
    LOADED: "cv_loaded",
    DELETED: "cv_deleted",
    UPDATED: "cv_updated",
    EXPORTED: "cv_exported",
    IMPORTED: "cv_imported",
    TEMPLATE_CHANGED: "cv_template_changed",
    VERSION_CREATED: "cv_version_created",
    VERSION_SWITCHED: "cv_version_switched",
  },
  AI: {
    ANALYSIS_RUN: "ai_analysis_run",
    COVER_LETTER_GENERATED: "ai_cover_letter_generated",
    JOB_MATCH: "ai_job_match",
    CV_GENERATED: "ai_cv_generated",
    OPTIMIZE_RUN: "ai_optimize_run",
  },
  ATS: {
    SCORE_VIEWED: "ats_score_viewed",
    KEYWORDS_MATCHED: "ats_keywords_matched",
    SUGGESTIONS_APPLIED: "ats_suggestions_applied",
  },
  JOB: {
    IMPORTED: "job_imported",
    SOURCE_INDEED: "job_imported_indeed",
    SOURCE_LINKEDIN: "job_imported_linkedin",
    SOURCE_HELLOWORK: "job_imported_hellowork",
    SOURCE_MANUAL: "job_imported_manual",
  },
  AUTH: {
    SIGNED_IN: "auth_signed_in",
    SIGNED_UP: "auth_signed_up",
    SIGNED_OUT: "auth_signed_out",
    SIGNED_IN_GOOGLE: "auth_signed_in_google",
  },
  SESSION: {
    STARTED: "session_started",
    ENDED: "session_ended",
  },
} as const;

export type EventName = (typeof EVENTS)[keyof typeof EVENTS];

export interface CVEventProperties {
  cv_id?: string;
  template?: string;
  format?: "pdf" | "docx" | "json";
  version_count?: number;
}

export interface AIEventProperties {
  feature: string;
  provider?: string;
  tokens_used?: number;
  duration_ms?: number;
  success?: boolean;
}

export interface JobEventProperties {
  source: "indeed" | "linkedin" | "hellowork" | "manual";
  job_title?: string;
  company?: string;
  success?: boolean;
}

export interface AuthEventProperties {
  method: "email" | "google";
  success?: boolean;
}
